import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Steakhouse from '@/pages/Steakhouse';
import Tavern from '@/pages/Tavern';
import Venue from '@/pages/Venue';
import Gallery from '@/pages/Gallery';
import Contact from '@/pages/Contact';
import Careers from '@/pages/Careers';

import { ContentProvider } from '@/lib/content';
import ContentProtection from '@/components/ContentProtection';
import { AuthProvider } from '@/admin/AuthContext';
import AdminLayout from '@/admin/AdminLayout';
import Login from '@/admin/Login';
import PagesList from '@/admin/PagesList';
import PageEditor from '@/admin/PageEditor';
import MediaLibrary from '@/admin/MediaLibrary';
import Account from '@/admin/Account';
import Leads from '@/admin/Leads';
import Applications from '@/admin/Applications';
import Users from '@/admin/Users';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const PublicSite = () => (
  <ContentProvider>
    <div className="font-sans antialiased bg-[#f7f1e3] text-[#942222] content-protected">
      <ContentProtection />
      <Navbar />
      <main data-testid="app-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/steakhouse" element={<Steakhouse />} />
          <Route path="/tavern" element={<Tavern />} />
          <Route path="/venue" element={<Venue />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
      </main>
      <Footer />
    </div>
  </ContentProvider>
);

const AdminApp = () => (
  <AuthProvider>
    <Routes>
      <Route path="login" element={<Login />} />
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="pages" replace />} />
        <Route path="pages" element={<PagesList />} />
        <Route path="pages/:slug" element={<PageEditor />} />
        <Route path="media" element={<MediaLibrary />} />
        <Route path="leads" element={<Leads />} />
        <Route path="applications" element={<Applications />} />
        <Route path="users" element={<Users />} />
        <Route path="account" element={<Account />} />
      </Route>
    </Routes>
  </AuthProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/*" element={<PublicSite />} />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#942222',
              color: '#f1ead9',
              border: '1px solid #e2b95a',
              borderRadius: 0,
              fontSize: '13px',
              letterSpacing: '0.05em',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
